import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localize'
})
export class LocalizePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {

  }
  transform(value: any, ...args: unknown[]): string {
    if (!value) return value;

    if (typeof value === "string") return value;
    return value[this.translateService.currentLang];
  }

}
